/**
 * @generated SignedSource<<13f4bca056f3977b645e1b9125894a3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StarButtonBlogPostCardStarFragment$data = {
  readonly viewer: {
    readonly favoritedSummary: {
      readonly isFavorite: boolean;
    } | null;
  } | null;
  readonly " $fragmentType": "StarButtonBlogPostCardStarFragment";
};
export type StarButtonBlogPostCardStarFragment$key = {
  readonly " $data"?: StarButtonBlogPostCardStarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StarButtonBlogPostCardStarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StarButtonBlogPostCardStarFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostViewerSummary",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceFavoritedSummary",
          "kind": "LinkedField",
          "name": "favoritedSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavorite"
            }
          ]
        }
      ]
    }
  ],
  "type": "ConfluenceBlogPost"
};

(node as any).hash = "2f3c7e7edda1297f958e48ce6c8828a2";

export default node;
